import React from "react";
import { IoInformationCircleOutline } from "react-icons/io5";

const IndustryCardCompact = ({
  infoIcon = <IoInformationCircleOutline />,
  item,
}) => {
  return (
    <div
      className={`industryCard industryCard--compact ${
        item?.show ? "industryCard--enabled" : "industryCard--disabled"
      }`}
    >
      <div className="industryCard__header">
        <div className="industryCard__logo">
          {item?.logoStorage ? (
            <img src={item?.logoStorage} alt={item?.name} />
          ) : (
            <div className="industryCard__logo__placeholder">
              <span>{item?.name?.charAt(0)?.toUpperCase()}</span>
            </div>
          )}
        </div>
        <div className="industryCard__title">
          <h3>{item?.name}</h3>
        </div>
        <div className="industryCard__infoIcon">{infoIcon}</div>
      </div>
    </div>
  );
};

export default IndustryCardCompact;
